<template>
    <div>
      <h1>Bulk Registration</h1>
      <p>Register multiple users at once.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BulkRegistration',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>